<template>
  <div class="electronic-quantity">
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div style="display: flex; justify-content: space-between">
        <div class="btn-box" v-if="billType === '2'">
          <el-date-picker v-model="timeValue" type="daterange" size="small" unlink-panels @change="changeTimeValue" value-format="yyyy-MM-dd" range-separator="至" :picker-options="pickerOptions2" start-placeholder="开始日期" end-placeholder="结束日期"> </el-date-picker>
        </div>
        <div class="btn-box" v-if="billType === '3'">
          <el-date-picker v-model="timeValue2" type="month" size="small" value-format="yyyy-MM" @change="changeTimeValue" placeholder="请选择月份"> </el-date-picker>
        </div>
        <!--<button-export value="公摊蒸汽模板" :href="exportUrl" download="download.xls" :beforeDownload="beforeDownload" style="margin: 0 0 0 10px" />-->
        <!--<button-upload-->
        <!--:cathUrl="uploadUrl"-->
        <!--:onSuccess="uploadSuccess"-->
        <!--@getpage="getPage"-->
        <!--style="margin: 0"-->
        <!--value="导入公摊蒸汽"/>-->
      </div>
      <div style="display: flex; justify-content: space-between">
        <!--<input-select selectTitle="场景" :selectKey="'steamMeterSceneCode'" selectWidth="120px" :selectData="sceneList" @search="search" style="margin-right: 5px;"/>-->
        <input-select selectTitle="蒸汽类型" :selectKey="'useType'" selectWidth="100px" :selectData="useTypeList" @search="search" style="margin-right: 5px" />
        <div class="top-search-box">
          <div style="margin-right: 10px">统计周期</div>
          <el-radio v-model="billType" label="2" style="margin-right: 0">按天</el-radio>
          <el-radio v-model="billType" label="3">按月</el-radio>
        </div>
      </div>
      <div style="display: flex; justify-content: space-between">
        <input-search placeholder="住户名称/房间号" @search="searchKey" style="margin-right: 5px" />
        <!--<button-export-->
        <!--:href="exportUrl"-->
        <!--download="download.xls"-->
        <!--:beforeDownload="beforeDownload"-->
        <!--value="导出"-->
        <!--v-if="permissionCodes.indexOf('005002001') !== -1"/>-->
      </div>
    </div>
    <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" @changeSelection="changeSelection" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" :hasOperation="false" />
  </div>
</template>

<script>
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
import ButtonAdd from '../../../components/Button/ButtonAdd'
import ButtonDelete from '../../../components/Button/ButtonDelete'
import ButtonExport from '../../../components/common/buttons/button-export'
import ButtonUpload from '../../../components/common/buttons/button-upload'
import InputSearch from '../../../components/Input/InputSearch'
import InputSelect from '../../../components/Input/InputSelect'
import TableMain from '../../../components/Table/TableMain'
import { api } from '../../api/SteamManagement'
import { errorHandler } from '../../../utils/errorHandler'
import { bus } from '../../../utils/bus'
import { nSuccess } from '../../../utils/notice'

export default {
  components: {
    TableMain,
    InputSelect,
    InputSearch,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    ButtonAdd,
    Breadcrumb,
  },
  name: 'steam-quantity-public',
  data() {
    return {
      breadcrumb: [
        {
          value: '智慧蒸汽',
          name: 'steam-over-view',
        },
        {
          value: '蒸汽统计',
        },
      ],
      // addCustom: 'amount-add',
      exportUrl: '',
      uploadUrl: '',
      permissionCodes: '',
      pickerOptions2: {
        disabledDate(time) {
          return time.getTime() > new Date((new Date() / 1000 + 86400) * 1000)
        },
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            },
          },
        ],
      },
      billTypeList: [
        {
          key: '',
          label: '全部',
        },
        {
          key: '1',
          label: '时',
        },
        {
          key: '2',
          label: '天',
        },
        {
          key: '3',
          label: '月',
        },
      ],
      useTypeList: [
        {
          key: '',
          label: '全部',
        },
        {
          key: '1',
          label: '充值',
        },
        {
          key: '2',
          label: '抄表',
        },
      ],
      tableHead: [
        {
          prop: 'relateEnterpriseName',
          label: '住户名称',
        },
        {
          prop: 'relateRoom',
          label: '房间号',
        },
        {
          prop: 'coldCommon',
          label: '蒸汽量(吨)',
        },
        {
          prop: 'codeSteamFee',
          label: '蒸汽费(元)',
        },
        // {
        //   prop: 'hotCommon',
        //   label: '热蒸汽蒸汽量(吨)',
        // },
        // {
        //   prop: 'hotSteamFee',
        //   label: '热蒸汽蒸汽费(元)',
        // },
        {
          prop: 'billTime',
          label: '账单日期',
        },
      ],
      tableData: [],
      total: 0,
      pageSize: 10,
      pageNum: 1,
      selectionArr: [],
      timeValue: [],
      value2: '',
      timeValue2: '',
      billType: '2',
      sceneList: [],
      requestData: {
        steamMeterSceneCode: '',
        useType: '',
        searchKey: '',
        startTime: '',
        endTime: '',
        billType: '2',
      },
    }
  },
  created() {
    this.getCurrentTime()
    this.permissionCodes = bus.global.permissionCodes
    // this.uploadUrl = api.importsteamBillEnterprise
    // this.getPage()
    this.getsteamSceneList()
  },
  activated() {
    this.getsteamSceneList()
    this.getPage()
  },
  methods: {
    getCurrentTime() {
      let nowDate = new Date().getTime() - 24 * 60 * 60 * 1000
      let yesterday = new Date(nowDate)
      let year = yesterday.getFullYear()
      let month = yesterday.getMonth() + 1 < 10 ? '0' + (yesterday.getMonth() + 1) : yesterday.getMonth() + 1
      let date = yesterday.getDate() < 10 ? '0' + yesterday.getDate() : yesterday.getDate()
      // let hour = nowDate.getHours() < 10 ? '0' + nowDate.getHours() : nowDate.getHours()
      // let minute = nowDate.getMinutes() < 10 ? '0' + nowDate.getMinutes() : nowDate.getMinutes()
      // let second = nowDate.getSeconds() < 10 ? '0' + nowDate.getSeconds() : nowDate.getSeconds()
      this.timeValue[0] = year + '-' + month + '-' + date
      this.timeValue[1] = year + '-' + month + '-' + date
      this.timeValue2 = year + '-' + month
      this.getPage()
    },
    // 获取场景列表
    getsteamSceneList() {
      this.$axios
        .post(api.getSteamSceneList, {})
        .then((res) => {
          this.sceneList = [
            {
              key: '',
              label: '全部',
            },
          ]
          let list = res.data.data
          list.map((v) => {
            v.key = v.code
            v.label = v.name
            this.sceneList.push(v)
          })
        })
        .catch(errorHandler('获取场景列表失败'))
    },
    changeTimeValue() {
      this.pageNum = 1
      this.pageSize = 10
      this.getPage()
    },
    beforeDownload() {
      this.exportUrl = `${api.exportSteamBillEnterprise}?yq-app-code=${bus.global.yqCode}&kj-type=gy`
    },
    uploadSuccess(data) {
      const e = errorHandler('导入失败')(data)
      if (!(e instanceof Error)) {
        nSuccess('导入成功')
        this.getPage()
      }
    },
    getPage() {
      let reqData = this.requestData
      reqData.pageNum = this.pageNum
      reqData.pageSize = this.pageSize
      if (this.timeValue && this.billType === '2') {
        reqData.startTime = `${this.timeValue[0]}`
        reqData.endTime = `${this.timeValue[1]}`
      } else if (this.timeValue2 && this.billType === '3') {
        reqData.startTime = `${this.timeValue2}`
        reqData.endTime = `${this.timeValue2}`
      } else {
        reqData.startTime = ''
        reqData.endTime = ''
      }
      this.$axios
        .post(api.getSteamBillEnterprisePage, reqData)
        .then((res) => {
          if (res.data.retCode == 1) {
            let data = res.data.data.list
            data.map((v) => {
              if (v.useType === '1') {
                v.useTypeText = '充值'
              } else if (v.useType === '2') {
                v.useTypeText = '抄表'
              }
            })
            this.total = res.data.data.total
            this.tableData = data
          }
        })
        .catch(errorHandler('获取记录失败'))
    },
    searchKey(v) {
      this.pageNum = 1
      this.requestData.searchKey = v
      this.getPage()
    },
    search(v) {
      this.pageNum = 1
      this.requestData[v.key] = v.value
      this.getPage()
    },
    changePagination(data) {
      this.pageNum = data[0]
      this.pageSize = data[1]
      this.getPage()
    },
    changeSelection(codeArr) {
      this.selectionArr = codeArr
    },
  },
  watch: {
    billType(v) {
      this.requestData.billType = v
      this.pageNum = 1
      this.getPage()
    },
  },
}
</script>

<style scoped>
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
.btn-box {
  display: flex;
  justify-content: flex-start;
}
</style>

<style lang="less">
.btn-box {
  .el-date-editor .el-range-separator {
    padding: 0;
  }
}
.el-input--small .el-input__inner {
  line-height: 30px;
}
.top-search-box {
  display: flex;
  justify-content: flex-start;
  justify-items: center;
  line-height: 32px;
  .el-radio {
    line-height: 32px;
  }
  .el-radio + .el-radio {
    margin-left: 10px;
  }
  .el-radio__label {
    padding-left: 3px;
  }
}

.electronic-quantity {
  .el-date-editor {
    width: 260px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/SteamManage/SteamQuantityPublic/SteamQuantityPublic.vue